<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-900">
      <p>{{ gaUserList.name }}</p>
      <span class="text-xs text-gray-600">{{ gaUserList.id }}</span>
      -
      <span class="text-xs text-gray-600">{{ customerName }}</span>
    </td>
    <td class="px-4 py-4 text-sm text-gray-900 text-right">
      <span class="inline-block" v-tip="{ content: typeDescription.long }">{{
        typeDescription.short
      }}</span>
    </td>
    <td class="px-4 py-4 text-right text-sm text-gray-900">
      {{ sizeForDisplay }}
    </td>
    <td class="px-4 py-4 text-right text-sm text-gray-900 whitespace-nowrap">
      {{ gaUserList.size_range_for_display_description }}
    </td>
    <td class="px-4 py-4 text-right text-sm text-gray-900">
      {{ sizeForSearch }}
    </td>
    <td class="px-4 py-4 text-right text-sm text-gray-900 whitespace-nowrap">
      {{ gaUserList.size_range_for_search_description }}
    </td>
  </tr>
</template>
<script>
import Numbro from '@/utils/numbro';

const typeNameToDescription = {
  UNSPECIFIED: {
    short: 'Unspecified',
    long: 'Not specified',
  },
  UNKNOWN: {
    short: 'Unknown',
    long: 'Unknown',
  },
  REMARKETING: {
    short: 'Remarketing',
    long: 'Represented as a collection of conversion types',
  },
  LOGICAL: {
    short: 'Logical',
    long: 'Represented as a combination of other user lists/interests',
  },
  EXTERNAL_REMARKETING: {
    short: 'External Remarketing',
    long: 'Created in the Google Ad Manager platform',
  },
  RULE_BASED: {
    short: 'Rule based',
    long: 'Associated with a rule',
  },
  SIMILAR: {
    short: 'Similar',
    long: 'Similar to users of another UserList',
  },
  CRM_BASED: {
    short: 'Crm based',
    long: 'Of first-party CRM data provided by advertiser in the form of emails or other formats',
  },
};

export default {
  props: {
    gaUserList: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customerName() {
      return this.gaUserList?.ga_customer?.name || 'N/A';
    },
    sizeForDisplay() {
      return Numbro(this.gaUserList?.size_for_display || 0).format({
        thousandSeparated: true,
      });
    },
    sizeForSearch() {
      return Numbro(this.gaUserList?.size_for_search || 0).format({
        thousandSeparated: true,
      });
    },
    typeDescription() {
      const defaultDescription = {
        short: 'N/A',
        long: 'Not available',
      };

      return typeNameToDescription?.[this.gaUserList.type_name] || defaultDescription;
    },
  },
};
</script>
